// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let PlayIcon = class PlayIcon extends Vue {
};
PlayIcon = __decorate([
    Component({
        name: 'PlayIcon',
        template: '<span class="play-icon" role="presentation" />'
    })
], PlayIcon);
export { PlayIcon };
